import "./assets/scss/index.scss";
import "./plugins/element";
import "./assets/scss/element.scss";
import "default-passive-events";
import Vue from "vue";
import App from "./App.vue";
import "./plugins/axios";
import api from "./service/api";
import VueClipboard from "vue-clipboard2";
import loading from "./plugins/loading";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import { Format, SpecialTreatment } from "./tools/filter";
import "babel-polyfill";

Vue.config.productionTip = false;

Vue.prototype.$format = Format;

Vue.prototype.$st = SpecialTreatment;

Vue.prototype.$api = api;

VueClipboard.config.autoSetContainer = true;

Vue.use(VueClipboard);

Vue.use(loading);

Vue.prototype.$num = (val) => {
  if (!val) return "";
  let places = new RegExp(`\\D*(\\d*)(\\.?)(\\d{0,${6}})\\d*`);
  val = val.replace(/[^\d.]/g, "");
  val = val.replace(/^\./g, "");
  val = val.replace(/\.{2,}/g, ".");
  val = val.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
  val = val.replace(places, "$1$2$3");
  return val;
};

Vue.directive("title", {
  inserted: (el) => {
    document.title = el.dataset.title;
  },
  update: (el) => {
    document.title = el.dataset.title;
  },
});

Vue.directive("click-outside", {
  bind(el, bindings, vnode) {
    el.handle = (e) => {
      if (!el.contains(e.target)) {
        let method = bindings.expression;
        vnode.context[method]();
      }
    };
    document.addEventListener("click", el.handle);
  },
  unbind(el) {
    document.removeEventListener("click", el.handle);
  },
});

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
